import { Component } from '@opten/compiler/metadata/component';
import { getWindowScrollTop } from '@opten/dom/get-window-scroll-top';
import { toggleClass } from '@opten/dom/toggle-class';
import { debounce } from '@opten/reactive/debounce';
import { scrollToOffset } from '@opten/scroll/scroll-to-offset';

@Component({ className: 'js-page-top' })
export class PageTopComponent {
	constructor(
		private element: HTMLElement,
		private wrapper: HTMLElement | Window = window
	) {
		this.setVisibility();
		this.wrapper.addEventListener(
			'scroll',
			debounce(() => this.setVisibility(), 300)
		);
		element.addEventListener('click', (e) => {
			e.preventDefault();
			scrollToOffset(
				this.scrollTop() * -1,
				undefined,
				undefined,
				undefined,
				this.wrapper
			);
		});
	}

	private setVisibility() {
		toggleClass(this.element, 'is-visible', this.scrollTop() > 400);
	}

	private scrollTop() {
		if (this.wrapper instanceof Window || this.wrapper.clientHeight == 0) {
			return getWindowScrollTop();
		} else {
			return this.wrapper.scrollTop;
		}
	}
}
